import { usePlayerProfile } from '@/features/player/hooks/use-player-profile';
import type { PlayerProfileScreenParams } from '@/navigations/types';
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import React, { useEffect, type ComponentType } from 'react';

type PlayerProfileRoute = RouteProp<{ PlayerProfile: PlayerProfileScreenParams }, 'PlayerProfile'>;

export type WithActivePlayerInjectedProps = ReturnType<typeof usePlayerProfile>;

export function withActivePlayer<P extends object>(
  WrappedComponent: ComponentType<P & WithActivePlayerInjectedProps>,
) {
  function WithActivePlayerScreen(props: P) {
    const navigation = useNavigation();
    const route = useRoute<PlayerProfileRoute>();
    const playerId = route.params?.playerId;

    const playerProfile = usePlayerProfile(playerId);

    useEffect(() => {
      if (playerProfile.profile.inactive) {
        if (navigation.canGoBack()) navigation.goBack();
      }
    }, [navigation, playerProfile.profile.inactive]);

    if (playerProfile.profile.inactive) {
      return null;
    }

    return <WrappedComponent {...props} {...playerProfile} />;
  }

  WithActivePlayerScreen.displayName = `WithActivePlayer(${
    WrappedComponent.displayName ?? WrappedComponent.name ?? 'Screen'
  })`;

  return WithActivePlayerScreen;
}
